let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hB5eh")).then(() => parcelRequire('kBnhd'));